import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { AuthenticationService } from 'app/core/authentication/authentication.service';

@Injectable()
export class LoginGuardService implements CanActivate {

  constructor(public auth: AuthenticationService, public router: Router) {}

  private _validatesUser(): boolean {
    if (this.auth.isUserAuthenticated()) {
      console.log('Usuário já autenticado. Redirecionando para área restrita.');
      const user = this.auth.getLoggedUser();
      this.router.navigate([`/restrito/${user.pessoa.perfil}`]);
      return false;
    }
    return true;
  }

  canActivate(): boolean {
    return this._validatesUser();
  }

}
